<template>
  <div style="width: 603px">
    <p>
      Hier finden Sie teilnehmende, mittelständische Unternehmen unseres
      <strong>CSR-Netzwerkes.</strong> Suchen Sie nach Name, Stadt oder PLZ.
    </p>
    <div class="csr-search">
      <form @submit.prevent="search">
        <label for="firmq" class="search-label">Firmenname / Stadt / PLZ</label>
        <input type="text" v-model="q" class="search-input" />
        <button type="submit" class="search-button">Suchen</button>
      </form>
      <div v-if="firmsPaginated.length < 1" class="no-result">
        <h3>
          Es wurden leider keine Ergebnisse zu Ihrer Suchabfrage gefunden.
        </h3>
      </div>
      <div class="search-result" v-else>
        <div v-if="searched">
          <Pagination v-model="page" :total="firms.length" />
          <div class="cards">
            <Card
              v-for="firm in firmsPaginated"
              :key="firm._id"
              @mapClicked="openMap(firm)"
            >
              <FirmDetail :firm="firm" :logoHost="logoHost" />
            </Card>
          </div>
          <Pagination v-model="page" :total="firms.length" />
        </div>
      </div>
    </div>
    <Modal v-model="showModal">
      <Map :firms="firms" :selected="selectedFirm" />
    </Modal>
  </div>
</template>

<script>
import { get, sync, call } from 'vuex-pathify'
import { store } from '@/store'
import Pagination from '@/components/Pagination'
import Card from '@/components/Card'
import Modal from '@/components/Modal'
import FirmDetail from '@/components/FirmDetail'
import Map from '@/components/Map'

const fetchData = async (to, from, next) => {
  await store.dispatch('firms/list')
  next()
}

export default {
  beforeRouteEnter: fetchData,
  beforeRouteUpdate: fetchData,

  components: {
    Pagination,
    Card,
    Modal,
    FirmDetail,
    Map
  },

  data() {
    return {
      q: null,
      current: 1,
      searched: false,
      selectedFirm: {},
      showModal: false
    }
  },

  computed: {
    firms: get('firms/sortedList'),
    firmsPaginated: get('firms/paginatedList'),
    page: sync('firms/page'),
    limit: get('firms/limit'),
    sortOrder: sync('firms/sortOrder'),
    sortKey: sync('firms/sortKey'),
    searchTerm: sync('firms/searchTerm'),
    searchPresence: sync('firms/searchOptions@presence'),
    zipsList: get('zips/zipsList'),
    validZips() {
      return this.zipsList.length
    },
    logoHost() {
      return process.env.VUE_APP_API_HOST
    }
  },

  methods: {
    nearbyZips: call('zips/near'),
    async search() {
      if (!this.q) return
      this.searched = true
      if (!this.isZip()) {
        this.searchPresence = true
        this.searchTerm = this.q
        return
      }
      await this.nearbyZips({ zip: this.q })
      if (this.validZips) this.searchPresence = false
      this.searchTerm = this.validZips ? this.zipsList.join(' ') : this.q
    },
    isZip() {
      if (!this.q) return false
      return this.q.match(/^([0]{1}[1-9]{1}|[1-9]{1}[0-9]{1})[0-9]{3}$/)
    },
    openMap(firm) {
      this.selectedFirm = firm
      this.showModal = true
    }
  }
}
</script>

<style lang="scss" scoped>
.csr-search {
  text-align: center;
}
.search-label {
  font-size: 16px;
}
.search-input {
  border: 1px solid #ecebeb;
  font-family: inherit;
  font-size: inherit;
  max-width: 100%;
  padding: 0.75em 1em;
  // height: 40px;
  // font-size: 13px;
  // padding: 5px 10px;
  // border: none;
  // border-radius: 0;
  // color: #eb003c;
  margin: 0 6px;
  &:focus {
    outline: none;
  }
}
.search-button {
  border: 1px solid #eb003c;
  background-color: #eb003c;
  border-radius: 8px;
  color: #fff;
  padding: 5px 20px;
  color: rgb(255, 255, 255);
  font-family: open_sanssemibold, Arial, Helvetica, sans-serif;
  font-size: 15px;
  text-transform: uppercase;
  height: 40px;
  cursor: pointer;
  &:hover {
    background-color: #fff;
    border-radius: 8px;
    color: #eb003c;
  }
  &:focus {
    outline: none;
  }
}
.search-result {
  margin: 20px 0;
}
.search-pagination {
  clear: both;
  margin: 20px 0;
}
.cards {
  display: flex;
  flex-wrap: wrap;
}

.no-result {
  padding: 40px 0;
}
.vue-map-container .vue-map {
  width: 100% !important;
  height: 100% !important;
}
</style>
